import script from "./introduce.vue?vue&type=script&setup=true&lang=js"
export * from "./introduce.vue?vue&type=script&setup=true&lang=js"

import "./introduce.vue?vue&type=style&index=0&id=0c68080e&lang=scss&scoped=true"

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c68080e"]])

export default __exports__